import React, { PureComponent } from 'react';
import { generateFileUrl } from '../../../../apiHelper';

class MessagingChannelComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      member: null,
      unreadMessageCount: 0
    }
    this.getUnreadMessageCount = this.getUnreadMessageCount.bind(this);
  }

  componentWillMount() {
    //If messaging token has already exists attempt to use it
    let { channel } = this.props;
    channel.addListener('updated', this.getUnreadMessageCount);
    this.getUnreadMessageCount();
    this.getMember();
  }

  componentWillUnmount() {
    let { channel } = this.props;
    channel.removeListener('updated', this.getUnreadMessageCount);
  }

  //GET UNREAD MESSAGES
  getUnreadMessageCount() {
    let { channel, reorderChannels } = this.props;
    let that = this;
    setTimeout(function () {
      reorderChannels();
      channel.getUnconsumedMessagesCount().then(count => {
        that.setState({ unreadMessageCount: count });
      });
    }, 500);
  }

  //Get Members
  getMember() {
    let { channel, currentUserId } = this.props;
    channel.getUserDescriptors().then(users => {
      users.items.map(m => {
        if (m.identity !== currentUserId) {
          this.setState({
            user: {
              identity: m.identity,
              name: m.friendlyName,
              photo: m.attributes.photo
            }
          });
        }
      });
    });
  }

  render() {
    let { unreadMessageCount, user } = this.state;
    let { isSelected, onClick, channel, isMobile } = this.props;
    let divClasses = "message-channel d-flex";
    if (isSelected) { divClasses += " selected"; }
    return (<div className={divClasses} onClick={() => onClick(channel.uniqueName)}>
      {isMobile && <div className="back-image"><i alt="Back" className="fas fa-angle-left"></i></div>}
      <div className="channel-image">
        {user && user.photo && (<img src={generateFileUrl(user.photo, user.identity)} />)}
      </div>
      <div className="channel-name">
        {user ? user.name : 'Loading...'}
      </div>
      {unreadMessageCount > 0 && (<span className="unread-messages badge">{unreadMessageCount}</span>)}
    </div>);
  }
}

export default MessagingChannelComponent;
